import { Outlet } from "react-router-dom";
import { TopBar } from "@/components/TopBar";
import { Sidebar } from "@/components/Sidebar";

export default function Layout() {
  return (
    <div className="h-screen flex flex-col bg-white" data-testid="app-layout">
      <TopBar />
      <div className="flex flex-1 min-h-0">
        <Sidebar />
        <main className="flex-1 bg-slate-50 overflow-auto" data-testid="content-area">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
